"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _isChildOfType = require("../_utils/isChildOfType");
var _Button = _interopRequireDefault(require("../Button"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Content = _interopRequireDefault(require("./Content"));
var _excluded = ["visible", "onVisibleChange", "content", "trigger", "overlayClassName", "overlayStyle", "openDelay", "closeDelay", "closeOnScroll", "updateOnDimensionChange", "transitionTimeout", "referenceElement", "placement", "placementOffset", "animationScaleFrom", "children", "updateDeps", "escapeWithReference"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Bubble = function Bubble(props) {
  var visible = props.visible,
    onVisibleChange = props.onVisibleChange,
    content = props.content,
    trigger = props.trigger,
    overlayClassName = props.overlayClassName,
    overlayStyle = props.overlayStyle,
    openDelay = props.openDelay,
    closeDelay = props.closeDelay,
    closeOnScroll = props.closeOnScroll,
    updateOnDimensionChange = props.updateOnDimensionChange,
    transitionTimeout = props.transitionTimeout,
    referenceElement = props.referenceElement,
    placement = props.placement,
    placementOffset = props.placementOffset,
    animationScaleFrom = props.animationScaleFrom,
    children = props.children,
    _props$updateDeps = props.updateDeps,
    updateDeps = _props$updateDeps === void 0 ? [content] : _props$updateDeps,
    escapeWithReference = props.escapeWithReference,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  // 内容变化时更新位置
  var scheduleUpdateRef = (0, _react.useRef)(null);
  var deps = Array.isArray(updateDeps) ? updateDeps : [content];
  (0, _react.useLayoutEffect)(function () {
    return function () {
      if (scheduleUpdateRef.current) {
        scheduleUpdateRef.current();
      }
    };
  }, deps);

  // issue: https://github.com/facebook/react/issues/4251
  var finalChildren = children;
  if (_react.default.Children.count(children) === 1 && ((0, _isChildOfType.isChildOfType)(children, _Button.default) || (0, _isChildOfType.isChildOfType)(children, 'button')) && children.props.disabled) {
    // eslint-disable-next-line no-param-reassign
    finalChildren = /*#__PURE__*/_react.default.createElement("span", {
      style: {
        display: 'inline-block',
        cursor: 'not-allowed'
      }
    }, /*#__PURE__*/_react.default.cloneElement(children, {
      style: _objectSpread(_objectSpread({}, children.props.style || {}), {}, {
        pointerEvents: 'none'
      })
    }));
  }
  var offset = placementOffset || 10;
  return /*#__PURE__*/_react.default.createElement(_Popover.default, {
    visible: visible,
    onVisibleChange: onVisibleChange,
    closeOnScroll: closeOnScroll,
    trigger: trigger,
    placement: placement,
    placementOffset: offset,
    animationScaleFrom: animationScaleFrom,
    referenceElement: referenceElement,
    overlay: function overlay(_ref) {
      var scheduleUpdate = _ref.scheduleUpdate,
        placement = _ref.placement;
      scheduleUpdateRef.current = scheduleUpdate;
      if (!content && content !== 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Content.default, (0, _extends2.default)({}, rest, {
        placement: placement
      }), content);
    },
    overlayClassName: overlayClassName,
    overlayStyle: overlayStyle,
    openDelay: openDelay,
    closeDelay: closeDelay,
    updateOnDimensionChange: updateOnDimensionChange,
    transitionTimeout: transitionTimeout,
    escapeWithReference: escapeWithReference
  }, finalChildren);
};
Bubble.defaultProps = {
  trigger: 'hover',
  placement: 'top',
  closeOnScroll: false,
  placementOffset: 10,
  escapeWithReference: false
};
var _default = exports.default = Bubble;